import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/assistenza',
            name: 'network_assistenza',
            component: () => import("./views/assistenza.vue"),
            meta: {
                hasBar: true,
                appContainerClass: 'fullPage'
            }
        },
    ];
};